import { PopoverProps } from "@chakra-ui/react";
import { InfoIcon } from "../icons/reader/InfoIcon";
import { ArrowRightIcon } from "../icons/ArrowRightIcon";
import { CaretRightIcon } from "../icons/CaretRightIcon";
import { useTranslation } from "react-i18next";
import { KebabContextualMenu } from "../common/KebabContextualMenu";
import { ShareMenuItem } from "../common/ShareMenuItem";

export interface ReleaseCardMenuProps {
  onStartReading?: () => void;
  onContinueReading?: () => void;
  shareUrl?: string;
  onReleaseDetails?: () => void;
  onPreviewRelease?: () => void;
  backgroundColor?: string;
  menuPlacement?: PopoverProps["placement"];
  iconSize?: string;
  margin?: string;
}

export function ReleaseCardMenu({
  onReleaseDetails,
  shareUrl,
  onStartReading,
  onPreviewRelease,
  onContinueReading,
  backgroundColor = "transparent",
  menuPlacement = "bottom",
  iconSize = "20px",
  margin,
}: ReleaseCardMenuProps) {
  const { t } = useTranslation();

  const items = [];

  if (onStartReading) {
    items.push({
      id: "start-reading",
      text: t("components.cards.releaseCardMenu.startReading"),
      icon: (
        <CaretRightIcon
          boxSize="20px"
          transition="inherit"
          _groupHover={{ color: "blaze.blaze" }}
        />
      ),
      onClick: onStartReading,
    });
  }

  if (onContinueReading) {
    items.push({
      id: "continue-reading",
      text: t("components.cards.releaseCardMenu.continueReading"),
      icon: (
        <CaretRightIcon
          boxSize="20px"
          transition="inherit"
          _groupHover={{ color: "blaze.blaze" }}
        />
      ),
      onClick: onContinueReading,
    });
  }

  if (onPreviewRelease) {
    items.push({
      id: "preview-release",
      text: t("components.cards.releaseCardMenu.previewRelease"),
      icon: (
        <ArrowRightIcon
          boxSize="20px"
          transition="inherit"
          _groupHover={{ color: "blaze.blaze" }}
        />
      ),
      onClick: onPreviewRelease,
    });
  }

  if (onReleaseDetails) {
    items.push({
      id: "release-details",
      text: t("components.cards.releaseCardMenu.releaseDetails"),
      icon: (
        <InfoIcon
          boxSize="20px"
          transition="inherit"
          _groupHover={{ color: "blaze.blaze" }}
        />
      ),
      onClick: onReleaseDetails,
    });
  }

  if (shareUrl) {
    items.push({
      id: "share",
      text: t("components.cards.releaseCardMenu.share"),
      icon: <></>, // Not used for custom components
      onClick: () => {}, // Not used for custom components
      isLastItem: true,
      customComponent: (
        <ShareMenuItem
          key="share"
          shareUrl={shareUrl}
          shareTitle={t("components.slideInMenu.releaseInfoMenu.share")}
          isLastItem={true}
          popoverPlacement="top-start"
        />
      ),
    });
  }

  return (
    <KebabContextualMenu
      items={items}
      backgroundColor={backgroundColor}
      menuPlacement={menuPlacement}
      iconSize={iconSize}
      margin={margin}
      aria-label="Release options"
    />
  );
}
